import { useEffect } from 'react';

let lockCount = 0;
let savedScrollY = 0;

function lock(): void {
  if (lockCount === 0) {
    savedScrollY = window.scrollY;
    const { style } = document.body;
    style.position = 'fixed';
    style.top = `-${savedScrollY}px`;
    style.left = '0';
    style.right = '0';
    style.width = '100%';
  }
  lockCount += 1;
}

function unlock(): void {
  lockCount = Math.max(0, lockCount - 1);
  if (lockCount === 0) {
    const { style } = document.body;
    style.position = '';
    style.top = '';
    style.left = '';
    style.right = '';
    style.width = '';
    window.scrollTo(0, savedScrollY);
  }
}

/**
 * Locks body scroll (iOS-WebKit-safe) while `active`. Reference-counted at module
 * scope so stacked overlays lock once and unlock exactly once.
 */
export function useScrollLock(active: boolean): void {
  useEffect(() => {
    if (!active) return;
    lock();
    return unlock;
  }, [active]);
}
